import { useCallback } from 'react';
import { toast } from 'sonner';
import {
  ShowToastOptions,
  SonnerToastOptions,
} from '@/shared/types/notification.types';

export function useToastNotif() {
  const showToast = useCallback(
    ({
      type = 'success',
      message = 'Successfully created',
      toastOptions,
    }: ShowToastOptions) => {
      const notify = () => {
        const toastData: SonnerToastOptions = {
          position: 'top-right',
          ...toastOptions,
        };

        // Use type as a key to access the correct function in toast
        const getToastFn = () => {
          switch (type) {
            case 'success':
              toast.success(message, toastData);
              break;
            case 'info':
              toast.info(message, toastData);
              break;
            case 'warning':
              toast.warning(message, toastData);
              break;
            case 'error':
              toast.error(message, toastData);
              break;
            default:
              toast(message, toastData); // Fallback for any other type
          }
        };

        return getToastFn();
      };

      return notify();
    },
    [],
  );

  return {
    showToast,
  };
}
